export default __webpack_public_path__ + "static/media/drmc-art.d5a60b46.jpg";